var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{attrs:{"color":"green"}},[_c('v-tab',[_vm._v("Attive")]),_c('v-tab',[_vm._v("Evase")]),_c('v-tab-item',[_c('ConsegneAttive')],1),_c('v-tab-item',[_c('ConsegneEvase')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }